import router from '@/router/routes'
import request from '@/utils/request'
import { getValueByKeyPath } from '@/utils/common'
import crm from './crm'
import onboardingManagement from './onboardingManagement'
import { MICRO_SITE_TYPE } from '@/constant/common'
import satisfactionSurveyManagement from './satisfactionSurveyManagement'
import postApplicantManagement from './postApplicantManagement'
import jobApplicationManagement from './jobApplicationManagement'

function formatSiteDataResp (resp, { en, cn, tc }, { mEn, mCn, mTc }) {
  const result = {
    originResponse: resp,
    pc: { en: null, cn: null, tc: null },
    mobile: { en: null, cn: null, tc: null }
  }
  if (en) {
    result.pc.en = formatSiteData(getValueByKeyPath(resp, en))
  }
  if (cn) {
    result.pc.cn = formatSiteData(getValueByKeyPath(resp, cn))
  }
  if (tc) {
    result.pc.tc = formatSiteData(getValueByKeyPath(resp, tc))
  }
  if (mEn) {
    result.mobile.en = formatSiteData(getValueByKeyPath(resp, mEn))
  }
  if (mCn) {
    result.mobile.cn = formatSiteData(getValueByKeyPath(resp, mCn))
  }
  if (mTc) {
    result.mobile.tc = formatSiteData(getValueByKeyPath(resp, mTc))
  }
  return result
}

function formatSiteData (siteData) {
  siteData = typeof siteData === 'string' ? JSON.parse(siteData) : siteData
  return siteData ? { pages: siteData.pages, theme: siteData.theme } : null
}

export default {
  getSiteDataById: (id, type) => {
    if (type === MICRO_SITE_TYPE.onboarding) {
      return onboardingManagement.getMicroSitePageConfigById(id)
        .then(resp => formatSiteDataResp(
          resp,
          { en: 'web_en_site_data', cn: 'web_cn_site_data', tc: 'web_tc_site_data' },
          { mEn: 'mobile_en_site_data', mCn: 'mobile_cn_site_data', mTc: 'mobile_tc_site_data' }
        ))
    } else if (type === MICRO_SITE_TYPE.crm) {
      return crm.getMicrositeByUrl(id).then(resp => formatSiteDataResp(
        resp,
        { en: 'pc_en', cn: 'pc_cn' },
        { mEn: 'mobile_en', mCn: 'mobile_cn' }
      ))
    } else if (type === MICRO_SITE_TYPE.crmCampaign) {
      return crm.getCampaignByUrl(id).then(resp => formatSiteDataResp(
        resp,
        { en: 'microsite.pc_en', cn: 'microsite.pc_cn' },
        { mEn: 'microsite.mobile_en', mCn: 'microsite.mobile_cn' }
      ))
    } else if (type === MICRO_SITE_TYPE.satisfaction_survey) {
      return satisfactionSurveyManagement.getMicroSitePageConfigById(id)
        .then(resp => formatSiteDataResp(
          resp,
          { en: 'web_en_site_data', cn: 'web_cn_site_data', tc: 'web_tc_site_data' },
          { mEn: 'mobile_en_site_data', mCn: 'mobile_cn_site_data', mTc: 'mobile_tc_site_data' }
        ))
    } else if (type === MICRO_SITE_TYPE.post_applicant) {
      return postApplicantManagement.getMicroSitePageConfigById(id)
        .then(resp => formatSiteDataResp(
          resp,
          { en: 'web_en_site_data', cn: 'web_cn_site_data', tc: 'web_tc_site_data' },
          { mEn: 'mobile_en_site_data', mCn: 'mobile_cn_site_data', mTc: 'mobile_tc_site_data' }
        ))
    } else if (type === MICRO_SITE_TYPE.job_application) {
      return jobApplicationManagement.getMicroSitePageConfigById(id)
        .then(resp => formatSiteDataResp(
          resp,
          { en: 'web_en_site_data', cn: 'web_cn_site_data', tc: 'web_tc_site_data' },
          { mEn: 'mobile_en_site_data', mCn: 'mobile_cn_site_data', mTc: 'mobile_tc_site_data' }
        ))
    }
  },
  updateSiteData: (params, type) => {
    if (type === MICRO_SITE_TYPE.onboarding) {
      const pageType = `${params.isMobile ? 'mobile' : 'pc'}_${params.languageCode === 'en' ? 'en' : 'cn'}`
      const config = JSON.stringify(params.siteData)
      const microsite = {
        id: params.siteData.id,
        use_url_code: true,
        [pageType]: config
      }
      return onboardingManagement.updateMicroSite(microsite)
    } else if (type === MICRO_SITE_TYPE.crm) {
      const pageType = `${params.isMobile ? 'mobile' : 'pc'}_${params.languageCode === 'en' ? 'en' : 'cn'}`
      const config = JSON.stringify(params.siteData)
      return crm.updateMicrositeConfig(params.siteData.id, pageType, config, params.jobIds)
    } else if (type === MICRO_SITE_TYPE.satisfaction_survey) {
      const pageType = `${params.isMobile ? 'mobile' : 'pc'}_${params.languageCode === 'en' ? 'en' : 'cn'}`
      const config = JSON.stringify(params.siteData)
      const microsite = {
        id: params.siteData.id,
        use_url_code: true,
        [pageType]: config
      }
      return satisfactionSurveyManagement.updateMicroSite(microsite)
    } else if (type === MICRO_SITE_TYPE.post_applicant) {
      const pageType = `${params.isMobile ? 'mobile' : 'pc'}_${params.languageCode === 'en' ? 'en' : 'cn'}`
      const config = JSON.stringify(params.siteData)
      const microsite = {
        id: params.siteData.id,
        use_url_code: true,
        [pageType]: config
      }
      return postApplicantManagement.updateMicroSite(microsite)
    } else if (type === MICRO_SITE_TYPE.job_application) {
      const pageType = `${params.isMobile ? 'mobile' : 'pc'}_${params.languageCode === 'en' ? 'en' : 'cn'}`
      const config = JSON.stringify(params.siteData)
      const microsite = {
        id: params.siteData.id,
        use_url_code: true,
        [pageType]: config
      }
      return jobApplicationManagement.updateMicroSite(microsite)
    }
  },
  getCompanyTree: () => {
    return request.get('/django_rest/crm/microsite/company/')
  },
  getCompanyJob: (companyIds) => {
    return request.post('/django_rest/crm/microsite/company/job/', { company_ids: companyIds })
  },
  getJob: (params) => {
    const currentRoute = router.currentRoute
    params.is_campaign = currentRoute.path.includes('/recruiting/crm/campaign/')
    return request.post('/django_rest/crm/microsite/job/', params)
  },
  getMicrositeFormSubmitData: (params) => {
    return request.get('/django_rest/crm/microsite/custom-form/', { params })
  },
  submitMicrositeFormData: (params) => {
    return request.post('/django_rest/crm/microsite/custom-form/', params)
  },
  updateMicrositeFormData: (params) => {
    return request.put('/django_rest/crm/microsite/custom-form/', params)
  },
  createMicrositeFormExportTask: (params) => {
    return request.post('/django_rest/crm/campaign/form/export/', params)
  },
  getMicrositeFormExportData: (params) => {
    return request.get('/django_rest/crm/campaign/form/export/', { params })
  }

}
